module.exports = __webpack_public_path__ + "img/confirm-ok-icon.svg";